import { useGetItineraryDataQuery } from '@/src/api/rtkQuery/itineraryApi'
import useGetItineraryId from '@/src/hooks/itinerary/useGetItineraryId'
import useFormatCurrency from '../useFormatCurrency'

const useFormatCurrencyForItinerary = () => {
    const itineraryId = useGetItineraryId()
    const { formatCurrency } = useFormatCurrency()
    const { currencyConversionDetails } = useGetItineraryDataQuery(
        {
            itineraryId
        },
        {
            selectFromResult: ({ data }) => {
                return {
                    currencyConversionDetails: data?.currencyConversionDetails
                }
            }
        }
    )
    const formatCurrencyForItinerary = (price: number, usePrecision: boolean = true) => {
        const { buffer = 1, rate = 1, to: toCurrency = '' } = currencyConversionDetails || {}
        return formatCurrency({
            toCurrency,
            rate,
            buffer,
            price,
            usePrecision
        })
    }

    return {
        formatCurrency: formatCurrencyForItinerary
    }
}

export default useFormatCurrencyForItinerary
